import React from 'react';
import {
    Typography,
    Divider,
    Button,
    Card,
} from '@mui/material';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import ShareIcon from '@mui/icons-material/Share';
import CardMedia from '@mui/material/CardMedia';
import A8AdMyVision from '../../components/A8/A8AdMyVision';
import CATEGORY_IMAGE from '../../../static/biz-professional/bonsai-4634225_1280.jpeg';
import { useNavigate } from 'react-router-dom';

interface ArticlePageProps {
    path: string;
}


const Article: React.FC<ArticlePageProps> = ({ path }) => {
    const handleCopyClick = () => {
        navigator.clipboard.writeText(path)
            .then(() => {
                console.log('Link copied to clipboard!');
            })
            .catch((err) => {
                console.error('Unable to copy link to clipboard', err);
            });
    };

    const navigate = useNavigate()
    const handleImageClick = (path: string) => {
        navigate(path);
        window.scrollTo(0, 0);
    };
    return (
        <div>
            <Box sx={{ mt: 7, mb: 12, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                <Card elevation={0} sx={{ maxWidth: 1000 }} style={{ margin: '0px', padding: '5px' }}>
                    <CardContent>
                        <Typography variant="h1" id="introduction" style={{ fontSize: '30px' }}>
                            番外編: ビジネスプロフェッショナルの必読書5選。世界で通用する共通言語を学ぶ。。
                        </Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="body2" color="text.primary">
                            Published on 2024 Jan 17th <br />
                            10 min read  <br />
                            by Michelle
                        </Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="h5">
                            これまで7回に渡り、プレゼンテーションスキルを詳細に解説していきました。まずは、全ての記事を読破したみなさん。
                            本当にお疲れ様でした。 <br /> <br />

                            ソフトスキルとして語られがちなプレゼンテーションスキルは実は体系的な理論が存在していることを肌で感じでいただけたかなと思います。
                            ここまできた皆様は既に現場で一目置かれるプレゼンテーションの基礎が出来上がっていますし、部下に対してプロフェッショナルとしての指導もできるでしょう。 <br /> <br />

                            今回は番外編ですので、プレゼンテーションという文脈を超えますが、ビジネスプロフェッショナルとしてステップアップするための必読書をご紹介したいと思います。
                            大企業の役員をはじめとするビジネスプロフェッショナルは天性の素質でその才能を語られがちですが、膨大なインプットをしている方々ばかりです。
                            実際には一定の素質を持ち合わせているのは勿論ですが、そのような人と仕事を推し進めていく上で、彼らの共通言語を学ばないわけにはいきません。<br /> <br />

                            下記に紹介する本を全て読破することで、ビジネスプロフェッショナルの共通言語として
                            長きに渡り継承されてきた重要なコンセプトを身につけることができるでしょう。
                            <br /> <br />
                        </Typography>
                    </CardContent>
                    <CardContent>
                        <Button variant="text" size="small" endIcon={<ShareIcon />} style={{ color: 'black' }} onClick={handleCopyClick}>
                            Copy URL of this ariticle
                        </Button>
                    </CardContent>
                    <CardMedia
                        component="img"
                        height="500"
                        sx={{

                            objectFit: 'cover',
                            filter: 'grayscale(90%)',
                        }}
                        image={CATEGORY_IMAGE}
                        alt="image of the category"
                    />
                    <CardContent>
                        <Typography variant="body2" color="text.secondary">
                            番外編 ビジネスプロフェッショナルの必読書
                        </Typography>
                    </CardContent>
                    <Divider style={{ margin: '20px 0' }} />
                    <CardContent>
                        <Typography variant="h4" style={{ fontSize: '30px', fontWeight: 'lighter' }}>Table of Contents</Typography>
                    </CardContent>
                    <ol>
                        <li><a href="#1">ビジネスプロフェッショナルの必読書5選</a></li>
                        <li><a href="#3">最後に一言。</a></li>
                    </ol>
                    <Divider id="1" style={{ margin: '40px 0' }} />
                    <CardContent>
                        <Typography variant="h4" style={{ fontSize: '30px' }}>戦コン出身者が選ぶビジネスプロフェッショナルの必読書5選</Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="h5">
                            私が戦略コンサルティングファームに所属していたときに驚いたことは、各コンサルタントの知識量です。入社する前には所謂地頭の良さだけで戦うプロフェッショナルのような印象が強かったですが、
                            ジュニアメンバーからシニアメンバー（役員）を含めファームの中で活躍するコンサルタントは膨大なインプットをしていました。戦略コンサルのクライアントサイドも同様です。考えてみると当たり前ではありますが、
                            大企業の役員クラスともなると、その地頭の良さは勿論のこと、共通言語とも言えるビジネスの知識を体系的に理解しています。<br /><br />

                            逆にいうと、そのようなインプットなしにビジネスプロフェッショナルとての成功はないといっても過言ではないでしょう。是非、何度も読み返してみてください。
                            {/*  */}
                            <Divider id="2" style={{ margin: '40px 0' }} />
                            <Typography variant="h3" color="text.secondary" style={{ fontSize: '25px' }}>
                                企業価値とコーポレートファイナンス
                            </Typography>
                            <CardContent>
                                <Typography paragraph style={{ fontSize: '22px' }}>
                                    <a href="https://www.amazon.co.jp/%E4%BC%81%E6%A5%AD%E4%BE%A1%E5%80%A4%E8%A9%95%E4%BE%A1-%E7%AC%AC7%E7%89%88-%E4%B8%8A-%E3%83%90%E3%83%AA%E3%83%A5%E3%82%A8%E3%83%BC%E3%82%B7%E3%83%A7%E3%83%B3%E3%81%AE%E7%90%86%E8%AB%96%E3%81%A8%E5%AE%9F%E8%B7%B5-%E3%83%9E%E3%83%83%E3%82%AD%E3%83%B3%E3%82%BC%E3%83%BC%E3%83%BB%E3%82%A2%E3%83%B3%E3%83%89%E3%83%BB%E3%82%AB%E3%83%B3%E3%83%91%E3%83%8B%E3%83%BC/dp/4478112878" target="_blank" rel="noopener noreferrer">
                                        企業価値評価 第7版[上] バリュエーションの理論と実践
                                    </a>
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    マッキンゼー・アンド・カンパニー (著)
                                </Typography>
                                <CardContent>
                                    <Typography paragraph style={{ fontSize: '20px' }}>
                                        企業価値や事業価値のファンダメンタルな考え方を網羅的に説明した一冊（上下巻）です。30年以上にわたり世界中の戦略コンサルタントに読まれてきた名著です。
                                        全てのビジネスプロフェッショナルの必読書でしょう。
                                    </Typography>
                                </CardContent>
                            </CardContent>
                            {/*  */}

                            {/*  */}
                            <Divider id="4" style={{ margin: '40px 0' }} />
                            <Typography variant="h3" color="text.secondary" style={{ fontSize: '25px' }}>
                                戦略論
                            </Typography>
                            <CardContent>
                                <Typography paragraph style={{ fontSize: '22px' }}>
                                    <a href="https://www.amazon.co.jp/o/ASIN/4478371520/diamondinc-22/" target="_blank" rel="noopener noreferrer">
                                        競争の戦略
                                    </a>
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    M.E.ポーター (著)
                                </Typography>
                                <CardContent>
                                    <Typography paragraph style={{ fontSize: '20px' }}>
                                        ハーバード大学経営大学院教授であり、競争戦略に関する第一人者として知られるマイケル・ポーターの名著。
                                        ファイブフォース分析やバリューチェーン分析など、現在でも広く利用されているビジネスフレームワークを生み出しました。
                                    </Typography>
                                </CardContent>
                            </CardContent>
                            {/*  */}

                            {/*  */}
                            <Divider id="3" style={{ margin: '40px 0' }} />
                            <Typography variant="h3" color="text.secondary" style={{ fontSize: '25px' }}>
                                マーケティング
                            </Typography>
                            <CardContent>
                                <Typography paragraph style={{ fontSize: '22px' }}>
                                    <a href="https://www.amazon.co.jp/%E3%82%B3%E3%83%88%E3%83%A9%E3%83%BC-%E3%82%B1%E3%83%A9%E3%83%BC%E3%81%AE%E3%83%9E%E3%83%BC%E3%82%B1%E3%83%86%E3%82%A3%E3%83%B3%E3%82%B0%E3%83%BB%E3%83%9E%E3%83%8D%E3%82%B8%E3%83%A1%E3%83%B3%E3%83%88-%E7%AC%AC12%E7%89%88-Philip-Kotler/dp/4621066161" target="_blank" rel="noopener noreferrer">
                                        コトラー&ケラーのマーケティング・マネジメント 第12版
                                    </a>
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    バーバラ・ミント (著)
                                </Typography>
                                <CardContent>
                                    <Typography paragraph style={{ fontSize: '20px' }}>
                                        マーケティングを学ぶ人の全ての人が読むべき名著です。世界中の経営大学院（MBA）の教科書として採用されています。
                                        初版は1968年に遡ります。
                                    </Typography>
                                </CardContent>
                            </CardContent>
                            {/*  */}

                            {/*  */}
                            <Divider id="5" style={{ margin: '40px 0' }} />
                            <Typography variant="h3" color="text.secondary" style={{ fontSize: '25px' }}>
                                ビジネスライティングスキル
                            </Typography>
                            <CardContent>
                                <Typography paragraph style={{ fontSize: '22px' }}>
                                    <a href="https://www.amazon.co.jp/%E6%96%B0%E7%89%88-%E8%80%83%E3%81%88%E3%82%8B%E6%8A%80%E8%A1%93%E3%83%BB%E6%9B%B8%E3%81%8F%E6%8A%80%E8%A1%93-%E5%95%8F%E9%A1%8C%E8%A7%A3%E6%B1%BA%E5%8A%9B%E3%82%92%E4%BC%B8%E3%81%B0%E3%81%99%E3%83%94%E3%83%A9%E3%83%9F%E3%83%83%E3%83%89%E5%8E%9F%E5%89%87-%E3%83%90%E3%83%BC%E3%83%90%E3%83%A9%E3%83%BB%E3%83%9F%E3%83%B3%E3%83%88/dp/4478490279" target="_blank" rel="noopener noreferrer">
                                        新版　考える技術・書く技術　問題解決力を伸ばすピラミッド原則
                                    </a>
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    バーバラ・ミント (著)
                                </Typography>
                                <CardContent>
                                    <Typography paragraph style={{ fontSize: '20px' }}>
                                        戦略ファームに入ると必読書として紹介される本の一つです。こちらもまた、20年以上にわたり世界中の戦略コンサルタントに読まれてきた名著です。
                                        プロのビジネスマンとしての求められる文章の書き方と構造化の方法論を説明しています。
                                    </Typography>
                                </CardContent>
                            </CardContent>
                            {/*  */}

                            {/*  */}
                            <Divider id="5" style={{ margin: '40px 0' }} />
                            <Typography variant="h3" color="text.secondary" style={{ fontSize: '25px' }}>
                                エクセルスキル
                            </Typography>
                            <CardContent>
                                <Typography paragraph style={{ fontSize: '22px' }}>
                                    <a href="https://www.amazon.co.jp/%E5%A4%96%E8%B3%87%E7%B3%BB%E9%87%91%E8%9E%8D%E3%81%AEExcel%E4%BD%9C%E6%88%90%E8%A1%93-%E8%A1%A8%E3%81%AE%E8%A6%8B%E3%81%9B%E6%96%B9-%E8%B2%A1%E5%8B%99%E3%83%A2%E3%83%87%E3%83%AB%E3%81%AE%E7%B5%84%E3%81%BF%E6%96%B9-%E6%85%8E%E6%B3%B0%E4%BF%8A/dp/4492557318/ref=sr_1_1?__mk_ja_JP=%E3%82%AB%E3%82%BF%E3%82%AB%E3%83%8A&crid=2LZ0VDZN36TPU&dib=eyJ2IjoiMSJ9.vpTQw7PXGcJ_67rAUhuQBgOBr347TM2Eupi69XSNbmuTLU_cTpqT6xqYezCRLdrwyI9NrKV2zk6plFCFV20ZT6iDKfN9V8ITmb8LByBNVvC2-kuA5fqfzMCNM2wFUFqh1r9SXVU_NXP9h-bTTCCQZ-qJHqTK52aGrFKAYfMsAqxLBIDsqXVSaFBi4veoTX3pjK1KXSHNqFQw6VH-aWly6hYw67rYWmc1QMLEuiSDckkBiKpUukr0uZXbE5pphw16novdDUG_zxjBbnQqRCrXbo_8g6h4yW4VhxHNs9YadnA.uQjzOMIJT6Ei64j2zvajF0UQH0_YYBMYl2C1q-tLOOo&dib_tag=se&keywords=%E3%82%A8%E3%82%AF%E3%82%BB%E3%83%AB+%E8%B2%A1%E5%8B%99&qid=1705672382&sprefix=%E3%82%A8%E3%82%AF%E3%82%BB%E3%83%AB+%E8%B2%A1%E5%8B%99%2Caps%2C429&sr=8-1" target="_blank" rel="noopener noreferrer">
                                        外資系金融のExcel作成術: 表の見せ方&財務モデルの組み方
                                    </a>
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    慎泰俊 (著)
                                </Typography>
                                <CardContent>
                                    <Typography paragraph style={{ fontSize: '20px' }}>
                                        モダンなビジネスプロフェッショナルは、（本サイトで説明しているプレゼンスキルに加えて）エクセルスキルも必須です。
                                        グローバルで通用するエクセルスキルの基礎を網羅的に説明している一冊です。
                                    </Typography>
                                </CardContent>
                            </CardContent>
                            {/*  */}
                        </Typography>
                    </CardContent>

                    <Divider id="4" style={{ margin: '40px 0' }} />
                    <CardContent>
                        <Typography variant="h4" style={{ fontSize: '30px' }}>最後に一言</Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="h5">
                            どんな分野であれ、その道のエキスパートは、先人たちが蓄積してきた膨大な知識体系をインプットすべきでしょう。
                            厳しいことをいうと、それらをインプットして初めて、他のビジネスプロフェッショナルと対峙するスタート地点に立てるのです。

                            ファンダメンタルな5冊を選んでみたので、決して簡単な道のりではないですが、是非読破してみてください。
                        </Typography>
                    </CardContent>

                    <Divider style={{ margin: '20px 0' }} />
                    <CardContent>
                        <A8AdMyVision />
                    </CardContent>
                    <Button
                        variant="text"
                        size="small"
                        endIcon={<ShareIcon />}
                        style={{ color: 'black' }}
                        onClick={() => handleImageClick("/")}
                    >
                        他のプレゼンテーションスキルを学ぶ（記事一覧へ）
                    </Button>
                </Card>
            </Box>
        </div>
    );
};

export default Article;
